import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./LoginHome.css";
import "../../assets/css/bundle.css";
import { useHistory } from "react-router-dom";
import "../../assets/css/modal.css";
import Carousel from "../../components/Carousel/Carousel";
import Tabs from "../../components/HomeTabs/Tabs.js";
import SearchBar from "../../components/HomeSearch/SearchBar.js";
import OrderItem from "../../components/OrderItem/orderItem.js";
import ChooseModal from "../../components/OrderItem/chooseModal";
import Pickup from "../../components/Pickup/Pickup";
import PickupDate from "../../components/PickupDate/PickupDate";
import TrackOrder from "../../components/TrackOrder/TrackOrder";
import TrackOrderNow from "../../components/TrackOrderNow/TrackOrderNow";
import ComponentLoader from "../../common/ComponentLoader.js";
import OrderLoader from "../../common/OrderLoader.js";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import { getMenubyId, getCategories, getProducts, getProductWithFilter, getBusinessLocation, checkCashRegister } from "../../actions/productActions";
import { useParams } from "react-router-dom";
import PopUp from "../../components/Modals/Popup";
import { HiOutlineLockClosed } from "react-icons/hi";
import useIntersection from './useIntersection';
import { useScrollPosition } from '@n8tb1t/use-scroll-position'

import './MenuItems.css'
import WhatsAppWidget from 'react-whatsapp-widget'
import 'react-whatsapp-widget/dist/index.css'
import { toast } from "react-toastify";



const MenuItems = (props) => {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [productDataModal, setProductDataModal] = useState("");
  const [showPickup, setShowPickup] = useState(false);
  const [showPickupDate, setShowPickupDate] = useState(false);
  const [showtrackOrder, setShowTrackOrder] = useState(false);
  const [showTrackNow, setShowTracknow] = useState(false);
  const [load, setLoad] = useState(false);
  const [error, setError] = useState(null);
  const [catload, setCatLoad] = useState(false);
  const [menus, setMenus] = useState([]);
  const [category, setCategory] = useState(null);
  const [nonEmptyCategoryIds, setNonEmptyCategoryIds] = useState(() => new Set());
  const [menuload, setMenuload] = useState(false);
  const [order, setOrder] = useState([]);
  const [lshow, setLshow] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [replaceContext, setReplaceContext] = useState(null);
  // ---------------------Product load after render--------------------------
  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(true), 300);
    return () => clearTimeout(timer);
  }, []);
  // -----------------------------------------------
  // 🔹 Pagination state
  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [justChangedCategory, setJustChangedCategory] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const didMountRef = useRef(false);
  const [errorShown, setErrorShown] = useState("");
  const bottomTriggered = useRef(false);
  let business_id = localStorage.getItem('business_id');
  let location_id = localStorage.getItem('location_id');
  let verifiedEmail = localStorage.getItem('verifiedEmail');
  useEffect(() => {
    if (!props.errors || !props.errors.message) return;

    const message = props.errors.message;
    const businessId = localStorage.getItem("business_id");

    const isBusinessIdMissing =
      !businessId ||
      businessId === "null" ||
      businessId === "undefined" ||
      businessId === "";

    // if business id missing → DON'T show toast
    if (isBusinessIdMissing) {
      return;
    }

    // Request failed with status code 500 (backend crash) or invalid business id
    const isInvalidBusinessId =
      message.includes("500") ||
      message.includes("Request failed") ||
      message.includes("Network Error");

    // wrong business id → DON'T show toast
    if (isInvalidBusinessId) {
      return;
    }

    // valid business id + real error → SHOW TOAST
    if (props.errors && props.errors.message && props.errors.message !== errorShown) {
      toast.error("Menu Items Error");
      setError(props.errors);
      setErrorShown(props.errors.message); // remember last shown message
    }
  }, [props.errors]);
  useEffect(() => {
    if (props.business_location !== undefined) {
      console.log('business_location ', props.business_location)
      console.log('category ', props.category)
    } else {
      console.log('business_location is U ', undefined)
    }
  }, []);

  useEffect(() => {
    if (location_id != null) {
      props.checkCashRegister(location_id);
    }
  }, []);

  useEffect(() => {
    if (!load) {
      if (business_id != null && location_id != null) {
        console.log(business_id, location_id, 'location_idlocation_idlocation_id')
        if (verifiedEmail === null) {
          history.push("/?business_id=" + business_id + "&location_id=" + location_id);
        }
        props.getCategories();
        props.getBusinessLocation();
        props.getProducts(1, limit);

        // One-off, unpaginated fetch used only to know which categories have
        // products, so the category tab bar doesn't have to wait for the
        // scrolling grid's paginated (20-at-a-time) loads to reveal them.
        // Does not touch the paginated `product` redux state used for scrolling.
        axios.post("/v1/get_category_products_do", {
          business_id: localStorage.business_id,
          business_location_id: localStorage.location_id,
          category_id: "0",
          page: 1,
          limit: 10000,
          platform: "foodDelivery",
        }).then((res) => {
          const items = res.data?.items || [];
          setNonEmptyCategoryIds(prev => {
            const next = new Set(prev);
            items.forEach((product) => {
              if (product?.category_id !== undefined) next.add(product.category_id);
            });
            return next;
          });
        }).catch(() => { });
      }
      setLoad(true);
    }

    // if (props.errors != null) {
    //    if (props.errors.message !== '') {
    //      toast.error("Menu Items Error")
    // history.push("/Error");
    //   setError(props.errors);
    // }
    //   }
    if (
      props.loading === false &&
      props.product !== null &&
      menuload === false
    ) {
      setMenus(props.product);
      setMenuload(true);
    }

    if (
      props.loading === false &&
      props.category !== null &&
      catload === false
    ) {
      setCategory(props.category);
      setCatLoad(true);
    }
  }, [load, error, props, order, menuload, catload, business_id, location_id]);
  // 🔹 Infinite scroll handler
  useEffect(() => {
    if (!menuload) return;
    const handleScroll = () => {
      if (isFetching || !hasMore || justChangedCategory) return;
      const scrollPosition =
        window.innerHeight + document.documentElement.scrollTop;

      const pageHeight = document.documentElement.offsetHeight;

      if (scrollPosition + 200 >= pageHeight) {

        if (bottomTriggered.current) return;

        bottomTriggered.current = true;
        setIsFetching(true);
        setPage((prev) => prev + 1);
      } else {
        bottomTriggered.current = false;
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);

  }, [isFetching, hasMore, justChangedCategory, menuload]);

  useEffect(() => {
    if (page === 1) return; // handled elsewhere

    const keyword = debouncedSearch || "";
    const searchBy = keyword ? "productSearch" : selectedCategoryId ? "category" : "";

    if (keyword) {
      // SEARCH ignores selected category
      props.getProductWithFilter(page, limit, "0", keyword, "productSearch", true);
    } else if (selectedCategoryId) {
      // CATEGORY filter
      props.getProductWithFilter(page, limit, selectedCategoryId, "", "category", true);
    } else {
      // fallback to all products
      props.getProducts(page, limit, true);
    }
    setIsFetching(true);
  }, [page, selectedCategoryId, debouncedSearch]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchValue);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchValue]);

  // Call API only once when debounced value changes
  // When search changes
  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    const trimmedSearch = (debouncedSearch || "").trim();

    if (trimmedSearch) {
      // 🔍 SEARCH MODE
      setPage(1);
      setMenus([]);
      setHasMore(true);
      setJustChangedCategory(true);
      setIsFetching(true);

      props.getProductWithFilter(1, limit, "0", trimmedSearch, "productSearch", true);
    } else {
      // 🔁 RETURN TO ALL PRODUCTS MODE
      setPage(1);
      setMenus([]);
      setHasMore(true);
      setJustChangedCategory(false); // <— critical: reset so scroll works again
      setIsFetching(true);

      props.getProducts(1, limit, true);
    }
  }, [debouncedSearch]);

  // 🔹 Listen for new product updates in Redux
  useEffect(() => {
    if (!props.product) return;

    const productArray = Array.isArray(props.product)
      ? props.product
      : Array.isArray(props.product?.data)
        ? props.product.data
        : [];

    if (page === 1 || justChangedCategory) {
      setMenus(productArray);
    } else if (isFetching) {
      setMenus(prev => {
        const prevArray = Array.isArray(prev) ? prev : [];
        if (!Array.isArray(productArray) || productArray.length === 0) {
          return prevArray;
        }
        const existingIds = new Set(prevArray.map(p => p.id));
        const uniqueNewProducts = productArray.filter(
          p => !existingIds.has(p.id)
        );
        if (uniqueNewProducts.length === 0) {
          return prevArray;
        }
        return [...prevArray, ...uniqueNewProducts];
      });
    }
    setIsFetching(false);
    setJustChangedCategory(false);

    if (productArray.length === 0) setHasMore(false);

    if (productArray.length > 0) {
      setNonEmptyCategoryIds(prev => {
        const next = new Set(prev);
        productArray.forEach(product => {
          if (product?.category_id !== undefined) next.add(product.category_id);
        });
        return next;
      });
    }

  }, [props.product]);

  const showPickFunction = () => {
    setShowModal(false);
    setShowPickup(true);
  };

  const pickupDateFunction = () => {
    setShowPickupDate(true);
    setShowPickup(false);
  };

  const trackOrderFunction = () => {
    setShowPickupDate(false);
    setShowTrackOrder(true);
  };

  const showTrackOrderNowFunction = () => {
    setShowTrackOrder(false);
    setShowTracknow(true);
  };

  const trackOrderPage = () => {
    setShowTracknow(true);
    history.push("/track-order");
  };

  const ProductModel = (data) => {
    setShowModal(true);
    setProductDataModal(data);
  };

  const ProductsRender = () => {
    if (!category || Object.keys(category).length === 0) return null;

    // Create a local mapping of products to categories to avoid mutating props
    const productsByCategory = {};

    // Initialize product arrays for each category
    Object.keys(category).forEach(key => {
      productsByCategory[category[key].id] = [];
    });

    // Populate the mapping
    if (menus && menus.length > 0) {
      menus.forEach(product => {
        if (productsByCategory[product.category_id] !== undefined) {
          productsByCategory[product.category_id].push(product);
        }
      });
    }

    let html = [];
    const sortedKeys = Object.keys(category).sort(
      (a, b) => category[a].id - category[b].id
    );

    sortedKeys.forEach(function (key) {
      const categoryItem = category[key];
      const categoryProducts = productsByCategory[categoryItem.id] || [];
      const product_num = categoryProducts.length;

      if (product_num > 0) {
        html.push(
          <div id="menus" key={key} className={`ord-gutter con-${categoryItem.id}`} name={'con-' + categoryItem.id} >
            <div className="heading">
              <h3 >
                {categoryItem.name}<span>{product_num} items</span>
              </h3>
            </div>
            <OrderItem
              data={{ ...categoryItem, product: categoryProducts }}
              showChooseModal={ProductModel}
              AddToCaetrestrict={props.cashregister && props.cashregister.status === "closed" ? true : false}
            />
          </div>
        );
      }
    });

    return html;
  };

  const RenderWhatsappWidget = () => {
    if (props.business_location !== undefined && props.business_location !== null) {
      const whatsappNumber = props.business_location[0].mobile.split(' ').join('');
      return (
        <footer className="whatsapp-footer-container whatsapp-footer-container-small whatsapp-footer-container-large">
          <WhatsAppWidget textReplyTime="" companyName="Warely Corp" message="What can we do for you?" phoneNumber={whatsappNumber} />
        </footer>
      )
    }
    return null
  }

  const CashRegisterBanner = ({ cashregister }) => {
    if (props.cashregister && props.cashregister.status === "closed") {
      return (
        <div className="cash-register-banner">
          <div className="banner-content">
            <span className="banner-icon">
              <HiOutlineLockClosed size={16} />
            </span>
            <span className="banner-text">
              {props.cashregister.message ? props.cashregister.message : "Cash register is currently closed"}
            </span>
          </div>
        </div>
      );
    }
    return null;
  };
  // if(qrToken && category) {
  return (
    <div className="main-section">
      <PopUp text={"Added to cart successfully!"} show={lshow} closeModal={() => setLshow(false)}
      />
      <Carousel
        business_id={business_id}
        location_id={location_id}
      />

      <ChooseModal setOrder={setOrder} setLshow={() => setLshow(true)}
        order={order}
        show={showModal}
        product={productDataModal}
        replaceContext={replaceContext}
        updateCart={props.updateCart}
        closeModal={() => {
          setShowModal(false);
          setReplaceContext(null);
        }}
        showPickupModal={() => showPickFunction()}
        cashregister={props.cashregister}
      />
      <Pickup setOrder={setOrder} order={order} show={showPickup} closeModal={() => setShowPickup(false)}
        showPickupDate={() => pickupDateFunction()}
      />

      <PickupDate setOrder={setOrder} order={order} show={showPickupDate} closeModal={() => setShowPickupDate(false)}
        showTrackOrder={() => trackOrderFunction()}
      />

      <TrackOrder show={showtrackOrder} closeModal={() => setShowTrackOrder(false)}
        trackOrderNow={() => showTrackOrderNowFunction()}
      />

      <TrackOrderNow show={showTrackNow} closeModal={() => setShowTracknow(false)}
        trackOrder={() => trackOrderPage()}
      />
      {/* trackOrderNow={() => showTrackOrderNowFunction()} */}

      {/* ul */}

      {business_id != null && location_id != null ?
        <div className="tab-gutter">
          {!menuload ? (
            // <ComponentLoader />
            showLoader && !props.loading && <ComponentLoader />
          ) : (<><Tabs
            category={category}
            nonEmptyCategoryIds={nonEmptyCategoryIds}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            onCategorySelect={(catId, searchKeyword = "") => {
              setSelectedCategoryId(catId);
              setPage(1);
              setMenus([]);
              setHasMore(true);
              setJustChangedCategory(true);
              setIsFetching(true);
              setSearchValue("")
              if (catId === null && !searchKeyword) {
                props.getProducts(1, limit, true); // isPagination=true → no global Spinner
              } else {
                // Determine searchBy automatically
                const searchBy = searchKeyword ? "productSearch" : "category";
                props.getProductWithFilter(1, limit, catId || "0", searchKeyword, searchBy, true); // isPagination=true → no global Spinner
              }
            }}
          />
            <div className="tab-content" id="pills-tabContent">
              <div className="tab-pane fade show active" id="pills-1" role="tabpanel" aria-labelledby="pills-1-tab">
                <CashRegisterBanner cashregister={props.cashregister} />

                {menus && menus.length > 0 ? (
                  ProductsRender()
                ) : (
                  !isFetching && (
                    <div className="no-records">
                      <h4>No Records Found</h4>
                    </div>
                  )
                )}
                {(props.paginationLoading || isFetching) && (
                  <div style={{
                    position: "fixed",
                    top: "70px",
                    left: 0,
                    width: "100%",
                    height: "calc(100vh - 90px)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "rgba(255, 255, 255, 0.45)",
                    backdropFilter: "blur(1px)",
                    zIndex: 998,
                  }}>
                    <OrderLoader color="#ff0000" size={60} />
                  </div>
                )}
                {/* {RenderWhatsappWidget()} */}
              </div>
            </div></>
          )}
        </div>
        :
        <h2 className="text-center" style={{ marginTop: "100px" }}>Restaurant is not ready</h2>}

    </div>
  );

};

const mapStateToProps = (state) => ({
  // menus_by_id: state.products.get_menus_by_id,
  product: state.products.product,
  category: state.products.category,
  loading: state.products.loading,
  paginationLoading: state.products.paginationLoading,
  errors: state.products.errors,
  business_location: state.products.business_location,
  cashregister: state.products.cashregister,
  // qrToken: state.products.qrToken,
  // dine_in_detail : state.products.dine_in_detail
});
export default withTranslation()(
  connect(mapStateToProps, { getCategories, getProducts, getProductWithFilter, getBusinessLocation, checkCashRegister })(MenuItems)
);
